import React, { useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Services from '../../services/service';
import { Panel, PanelBody } from '../../components/panel/panel';

const ModalPreviewMobile = ({
  isOpen,
  toggle,
  selectedModule = null,
}) => {
  const [state, setState] = useState({
    file: '',
    previewUrl: null,
  });

  const [loadingModal, setLoadingModal] = useState(true);

  useEffect(() => {
    const getDetail = () => {
      const payload = { 
        id: selectedModule,
        type: "preview-from-checklist"
      };
      Services.getPreviewMobileQR(payload)
        .then(async (res) => {
          setState((prevState) => ({
            ...prevState,
            file: res.file,
          }));
          setLoadingModal(false);
        })
        .catch((error) => {
          setLoadingModal(false);
          console.log('error get preview mobile', error);
        });
    };
    
    if (selectedModule) {
      getDetail();
    }
  }, [selectedModule]);

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Preview Mobile</ModalHeader>
      <ModalBody>
        <Panel className={loadingModal ? 'panel-loading' : ''}>
          <PanelBody className="p-0 text-center">
            <img className="w-100" src={state.file} alt="qr-code"/>
            <h5>Scan QR Code untuk Preview di Mobile.</h5>
          </PanelBody>
        </Panel>
      </ModalBody>
      <ModalFooter>
        <button
          className="btn btn-white btn-xs me-1"
          onClick={toggle}
        >
          <i className="fa fa-times" /> Tutup
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default ModalPreviewMobile;
